import c from "classnames";
import { PropsWithChildren } from "react";

import classes from "./CardBody.module.css";

type Props = PropsWithChildren<{
  gap?: number;
  noPadding?: boolean;
  noOverflow?: boolean;
  grow?: boolean;
}>;

export const CardBody = ({
  gap = 0,
  noPadding,
  noOverflow,
  grow,
  ...rest
}: Props) => {
  return (
    <div
      className={c(
        classes.cardBody,
        noPadding && classes.noPadding,
        grow && classes.grow,
        noOverflow && classes.noOverflow,
      )}
      style={{ gap }}
      {...rest}
    />
  );
};
